import styles from "./styles/vocal-remover-player.module.scss";
import { useMusicPlayer } from "@/providers/music-provider/music-provider";
import PlayerProgress from "@/components/common/music-player/player-progress";
import React from "react";
import IconStateButton from "@/components/pages/home/components/voices/icon-state-button";
import playIcon from "@/assets/music-player/play.svg";
import playHover from "@/assets/voices/card/play-hover.svg";
import downloadIcon from "@/assets/icons/download-icon.svg";
import Image from "next/image";
import { useDownload } from "@/hooks/use-download";
import pauseActive from "@/assets/music-player/stop-pressed.svg";
import { useMobile } from "@/hooks/use-responsive";
import { LicenseName } from "@/data/license.data";

interface VocalRemoverPlayerProps {
  url: string;
  title: string;
  downloadTitle?: string;
  borderColor: string;
  onPlay: (url: string) => void;
  license: LicenseName;
  isLoadingLicense: boolean;
  shareButton: React.ReactElement;
}

const VocalRemoverPlayer = ({
  url,
  title,
  downloadTitle,
  borderColor,
  onPlay,
  license,
  isLoadingLicense,
  shareButton,
}: VocalRemoverPlayerProps) => {
  const {
    isPlaying,
    currentTrack,
    musicPlayer,
    progressRef,
    changeRange,
    calculateTime,
    onDurationChanged,
    onTimeUpdate,
    playPause,
    isTrackPlaying,
  } = useMusicPlayer();
  const { download } = useDownload();

  const { isMobile } = useMobile();

  return (
    <div className={styles.wrapper} style={{ borderColor: borderColor }}>
      <div className={styles.player}>
        <audio
          ref={musicPlayer}
          onDurationChange={onDurationChanged}
          onTimeUpdate={onTimeUpdate}
        />
        <div className={styles.player_header}>
          <IconStateButton
            baseIcon={playIcon}
            hoverIcon={playHover}
            activeIcon={isTrackPlaying(url) ? pauseActive : playIcon}
            onClick={() => playPause(url, onPlay)}
            size={40}
            isActive={isPlaying}
          />
          <div className={styles.title_progress_wrapper}>
            <div className={styles.title}>{title}</div>
            {isPlaying && url === currentTrack && !isMobile && (
              <PlayerProgress
                calculateTime={calculateTime}
                musicPlayer={musicPlayer}
                progressRef={progressRef}
                onChange={changeRange}
              />
            )}
          </div>
        </div>
        {downloadTitle &&
          !isLoadingLicense &&
          license !== "Trial" &&
          title !== "Original" && (
            <div className={styles.buttons_wrapper}>
              <Image
                src={downloadIcon}
                alt={""}
                onClick={() => download(url, downloadTitle)}
              />
              {shareButton}
            </div>
          )}
      </div>
      {isMobile && isPlaying && url === currentTrack && (
        <PlayerProgress
          calculateTime={calculateTime}
          musicPlayer={musicPlayer}
          progressRef={progressRef}
          onChange={changeRange}
        />
      )}
    </div>
  );
};

export default VocalRemoverPlayer;
